module.exports = __webpack_public_path__ + "static/media/lv.70d0fcd4.jpeg";